import React from 'react'
import ProjectInfo from '../ProjectInfo'
import tetris from "../../../../Assets/images/projects/tetrisdetailed.png"

export default function Tetris() {
    return (
        <ProjectInfo
            pic={tetris}
            title="Tetris Clone"
            maincolor="#25bb00"
            accentcolor="#0030c1"
            link=""
            githublink="https://github.com/Jrwolf99/TechnoBlock"
        >
            <p>Looking way too similar to Tetris, this game was developed to recreate a well-known retro game. It was developed using Raylib, a lightweight C++ game library, which utilizes OpenGL for rendering the graphics. </p>
            <br />
            <p>This game utilizes object-oriented programming in C++ and was developed and compiled in Microsoft's Visual Studio.</p>
            <br />
        </ProjectInfo>
    )
}
